export enum MetricImperial {
  Metric = "0",
  Imperial = "1",
}
